import * as React from "react";
import * as classNames from "classnames";
import * as P230Messages from "../../misc/api/DeviceLinkApi/P230In2itiveMessages";
import * as P230In2itiveApi from '../../misc/api/DeviceLinkApi/P230In2itive';
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";
import { AuditTrailActionEnum } from "../../misc/api/ApiAuditActions";

interface DiaryLaunchCalibrationVerificationProps {
    handleClose: () => void;
}

export const DiaryLaunchCalibrationVerification = ({ handleClose }: DiaryLaunchCalibrationVerificationProps) => {
    const [status, setStatus] = React.useState<string>();
    const [icon, setIcon] = React.useState("info");
    const client = useWebPortalApiClient();

    React.useEffect(() => {
        const accuracyCheck = async () => {
            setStatus(P230Messages.LaunchingCalibrationVerification);
            let selectedDevice = await P230In2itiveApi.ReConnectToDevice();
            try {
                await P230In2itiveApi.LaunchAccuracyRoutine(selectedDevice.id);
            } catch {
                setIcon("error");
                setStatus(P230Messages.FailedCalibrationVerification);
            }

            await client.client.postAuditTrailEvent({
                summary: `The In2itive eDiary '${selectedDevice.serial}' has launched a calibration verification.`,
                auditAction: AuditTrailActionEnum.LaunchCalibrationVerification
            });
            setStatus(P230Messages.SuccessCalibrationVerification);
            setIcon("success");
        }

        accuracyCheck();
    }, []);

    const textClass = classNames("text-center", {
        "text-success": icon === "success",
        "text-danger": icon === "error",
        "text-info": icon === "info"
    });

    const iconClass = classNames("fas", {
        "fa-check-circle": icon === "success",
        "fa-times-circle": icon === "error",
        "fa-circle-notch": icon === "info",
        "fa-spin": icon === "info"
    })

    return (
        <div>
            <div className="modal-header bg-primary">
                <h3 className="modal-title">Launching Calibration Verification</h3>
            </div>
            <div className="modal-body">
                <p style={{ fontSize: 100 + 'px' }} className={textClass}>
                    <i id="SuccessStatus" className={iconClass} aria-hidden="true"></i>
                </p>
                <div className="text-center">
                    {status}
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={handleClose}>Finish</button>
            </div>
        </div>
    );
}
